import { useState } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dagkvc1tto0ceqqnhud0";

type Status = { state: "idle" | "loading" | "success" | "error"; message: string };

export default function SubscribeSection() {
  const [status, setStatus] = useState<Status>({ state: "idle", message: "" });

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = String(fd.get("company_alt") || "").trim();
    if (honeypot) {
      setStatus({ state: "success", message: "订阅成功，感谢关注！" });
      form.reset();
      return;
    }
    fd.delete("company_alt");
    setStatus({ state: "loading", message: "" });
    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let code = "";
      try {
        const parsed = JSON.parse(text);
        code = parsed?.code || "";
      } catch {
        code = "";
      }
      const ok = res.ok && code === "OK";
      if (ok) {
        setStatus({ state: "success", message: "订阅成功，新料第一时间推送给你！" });
        form.reset();
      } else {
        setStatus({ state: "error", message: "提交失败，请稍后再试。" });
      }
    } catch {
      setStatus({ state: "error", message: "网络异常，请稍后再试。" });
    }
  }

  return (
    <section id="subscribe" className="relative scroll-mt-20 overflow-hidden bg-background-900">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-800/70 via-background-900 to-accent-700/40" />
      <div className="relative mx-auto max-w-4xl px-4 py-16 text-center md:px-6">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 text-xs font-medium text-background-100 ring-1 ring-background-50/30">
          <i className="ri-notification-4-line" />
          新料提醒
        </span>
        <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
          订阅新料提醒，热点不再错过
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-6 text-background-200">
          留下你的邮箱，当有重点爆料或重要更新时，我们第一时间推送提醒，随时跟上吃瓜节奏不落伍。
        </p>

        <form
          id="newsletter-form"
          data-readdy-form="newsl-sub"
          onSubmit={handleSubmit}
          className="mx-auto mt-7 flex max-w-xl flex-col gap-3 sm:flex-row sm:items-center"
        >
          <input
            name="company_alt"
            type="text"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />
          <label htmlFor="sub-email" className="sr-only">订阅邮箱</label>
          <input
            id="sub-email"
            name="email"
            type="email"
            required
            placeholder="请输入你的邮箱地址"
            className="w-full rounded-md border border-background-50/25 bg-background-50/95 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-500 focus:border-background-50 focus:outline-none focus:ring-2 focus:ring-background-50/40"
          />
          <button
            type="submit"
            disabled={status.state === "loading"}
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-950 transition-colors hover:bg-accent-400 disabled:opacity-60"
          >
            {status.state === "loading" ? "提交中..." : (
              <>
                <i className="ri-send-plane-fill" />
                立即订阅
              </>
            )}
          </button>
        </form>

        {status.state === "success" && (
          <p className="mx-auto mt-4 flex max-w-md items-center justify-center gap-1.5 rounded-md bg-background-50/15 px-4 py-2 text-sm text-background-50">
            <i className="ri-checkbox-circle-fill text-accent-300" />
            {status.message}
          </p>
        )}
        {status.state === "error" && (
          <p className="mx-auto mt-4 flex max-w-md items-center justify-center gap-1.5 rounded-md bg-primary-500/30 px-4 py-2 text-sm text-background-50">
            <i className="ri-error-warning-line" />
            {status.message}
          </p>
        )}
        <p className="mt-4 text-xs text-background-300">免费订阅 · 随时可退订 · 我们尊重你的隐私</p>
      </div>
    </section>
  );
}